export const CoinbaseIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 16C4 14.4241 4.31039 12.8637 4.91345 11.4078C5.5165 9.95189 6.40042 8.62902 7.51472 7.51472C8.62902 6.40042 9.95189 5.5165 11.4078 4.91345C12.8637 4.31039 14.4241 4 16 4C17.5759 4 19.1363 4.31039 20.5922 4.91345C22.0481 5.5165 23.371 6.40042 24.4853 7.51472C25.5996 8.62902 26.4835 9.95189 27.0866 11.4078C27.6896 12.8637 28 14.4241 28 16C28 19.1826 26.7357 22.2348 24.4853 24.4853C22.2348 26.7357 19.1826 28 16 28C12.8174 28 9.76515 26.7357 7.51472 24.4853C5.26428 22.2348 4 19.1826 4 16Z"
      fill="#0E5BFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 24.5C18.2543 24.5 20.4163 23.6045 22.0104 22.0104C23.6045 20.4163 24.5 18.2543 24.5 16C24.5 13.7457 23.6045 11.5837 22.0104 9.98959C20.4163 8.39553 18.2543 7.5 16 7.5C13.7457 7.5 11.5837 8.39553 9.98959 9.98959C8.39553 11.5837 7.5 13.7457 7.5 16C7.5 18.2543 8.39553 20.4163 9.98959 22.0104C11.5837 23.6045 13.7457 24.5 16 24.5ZM15 13.5C14.172 13.5 13.5 14.172 13.5 15V17C13.5 17.828 14.172 18.5 15 18.5H17C17.828 18.5 18.5 17.828 18.5 17V15C18.5 14.172 17.828 13.5 17 13.5H15Z"
      fill="white"
    />
  </svg>
);
